import { actionConfirm } from './toast';
import { HttpClient } from './http';

// 防止circle import
let vue = async () => {
    return (await import('../main')).vue;
};

export async function removeModel(modelName, id) {
    await HttpClient.put('/restful', {
        model: modelName,
        cond: id,
        updates: {
            deleteStatus: 1,
        },
    });
}
